import {
  formatCurrency,
  transformDateToLocalDateString,
} from "helpers";
import { FleetVehicleContractSaleRow } from "services/api/fleet/vehicles/contracts/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";
import { getStatusBadgeVariant } from "services/api/offers/consts";
import Tooltip from "ui/components/Tooltip/Tooltip";
import ContactCell from "ui/components/Table/TableSearch/components/Cells/ContactCell";
import OfferCell from "ui/components/Table/TableSearch/components/Cells/OfferCell";

export const FLEET_VEHICLE_CONTRACT_SALE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleContactClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void,
  handleDeleteClick?: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.contract.sale.search.contractnumber",
      key: "contract_number",
      field: "contractNumber",
      type: ColumnTypes.string,
    },
     {
      title: "admin.fleet.vehicle.contract.sale.search.offerSale",
      key: "contract_offer",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return (
          <OfferCell offer={row.offerSale} />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.contract.sale.search.buyer",
      key: "contract_client",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return (
          <ContactCell
            contact={row.contactClient}
            onClick={(e) => row.contactClient?.id && handleContactClick(e, row.contactClient.id)}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.contract.sale.search.status",
      key: "contract_status",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        if (!row.status) return null;
        return (
          <Badge
            text={row.status.name}
            variant={getStatusBadgeVariant(row.status.color)}
            height="small"
            showDot={true}
          />
        );
      },
    },
   
    {
      title: "admin.fleet.vehicle.contract.sale.search.contractdate",
      key: "contract_date",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return (
          <div>{transformDateToLocalDateString(row.contractDate)}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.contract.sale.search.price",
      key: "contract_price",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => (
        <Tooltip
          decorate={<span className="text-md font-medium">{formatCurrency.format(row.sellingPrice ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[240px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled iznosa</div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Cijena bez PDV-a</span>
              <span className="font-medium">{formatCurrency.format(row.netPrice ?? 0)}</span>
            </div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">PDV</span>
              <span className="font-medium">{formatCurrency.format((row.sellingPrice ?? 0) - (row.netPrice ?? 0))}</span>
            </div>
            {(row.depositAmount ?? 0) > 0 && (
              <div className="flex justify-between text-sm mb-1">
                <span className="text-slate-300">Kapara</span>
                <span className="font-medium text-amber-400">{formatCurrency.format(row.depositAmount ?? 0)}</span>
              </div>
            )}
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno s PDV-om</span>
              <span className="font-bold text-green-400">{formatCurrency.format(row.sellingPrice ?? 0)}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Kreirao",
      key: "contract_created_by",
      defaultVisible: false,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return (
          <div className="text-sm text-slate-500">{row.userCreatedName ?? "-"}</div>
        );
      },
    },
    {
      title: "",
      key: "contract_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleContractSaleRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick?.(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];
